module.exports = __webpack_public_path__ + "themes/hm/font/SignPainter-HouseScript.ttf";


//////////////////
// WEBPACK FOOTER
// ./themes/hm/font/SignPainter-HouseScript.ttf
// module id = 136
// module chunks = 3